export default {
  LIST: 'VOD.LISTS.LIST',
  SEARCH: 'VOD.LISTS.SEARCH',
  REMOVE: 'VOD.LISTS.REMOVE',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/lists.js